@if (attachment(); as attachment) {
    <tran-base-file-item
        [fileName]="attachment.fileName"
        [fileSize]="attachment.size"
        [downloadEnabled]="false"
        [deleteEnabled]="true"
        (delete)="delete.emit(attachment)"
    />
}
